import React from "react";
import { useNavigate } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa6";
// import "./ImagineMainSection.css";

const HolisticMainSection = () => {
  const navigate = useNavigate();
  const servicesDummy = [
    {
      title: "Physiotherapy",
      path: '/service/physiotherapy',
      dept: 'PHYSIOTHERAPY',
      description:
        "Physiotherapy helps restore movement, reduce pain, and improve physical strength through guided exercises and therapeutic techniques...",
    },
    {
      title: "Ophthalmology",
      path: '/service/ophthalmology',
      dept: 'EYE ',
      description:
        "Ophthalmology focuses on diagnosing and treating eye-related conditions, ensuring clear vision and long-term visual health for patients...",
    },
    {
      title: "Dermatology",
      path: '/service/dermatology',
      dept: 'DERMA',
      description:
        "Dermatology involves the care and treatment of skin, hair, and nail conditions, offering solutions for both medical and cosmetic concerns...",
    },
    {
      title: "Dental Care",
      path: '/service/dental',
      dept: 'DENTAL',
      description:
        "Dental care includes preventive and corrective treatments that maintain oral hygiene, improve dental health, and enhance your smile...",
    },
    {
      title: "Home Care",
      path: "/service/homecare",
      dept: 'Home Care ',
      description:
        "Home care services provide medical support and monitoring at your doorstep, ensuring comfort, personalized treatment, and convenience...",
    },
  ];


  return (
    <div className="service-section">
      {/* <h2 className="service-title">Our Services</h2> */}

      <div className="grid-container">
        {servicesDummy.map((item, index) => (
          <div className="service-card" key={index}>
            <h3 className="service-card-title">{item.title}</h3>
            <p className="service-card-desc">{item.description}</p>

            {/* <button className="know-more-btn"  onClick={() => navigate(`/service/holistic/${item.dept}`)}>Know more &gt;</button> */}

            {/* <button className="rbdButton know-more-btn" onClick={() => navigate(item.path)}>
              Know more &gt;
            </button> */}

            <button
              className="rbdButton know-more-btn"
              onClick={() => navigate(item.path)}
            >
              <span className="btn-text text-btn">Know more <FaAngleRight /></span>
              {/* Know more &gt; */}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HolisticMainSection;
